import { h } from "preact";
import { useState } from "preact/hooks";
import siteSettings from "./siteSettings";
import peacockPhoto from "../images/peacock.jpg";
import "./corner_styles.css";

export default function CornerContact() {
  const [isFormVisible, setFormVisible] = useState(false);
  const [isConfirming, setConfirming] = useState(false);
  const [hasSent, setHasSent] = useState(false);
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState("");

  const updateField = (event) => setFormData({ ...formData, [event.target.name]: event.target.value });
  const reviewForm = (event) => {
    event.preventDefault();
    setConfirming(true);
  };
  const submitForm = async () => {
    setStatus("Sending…");
    try {
      const response = await fetch("/.netlify/functions/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData)
      });
      if (!response.ok) throw new Error("Unable to send message");
      setStatus("Thank you—your message is on its way.");
      setHasSent(true);
    } catch (error) {
      setStatus("Something went wrong. Please try again in a moment.");
    }
  };

  return (
    <main class="corner-page content-page narrow-page contact-page">
      <section class="contact-hero" data-scroll-reveal>
        <p class="eyebrow">Contact</p><h1>Let’s chat</h1><p class="page-intro">If you've made it this far, we probably have something to talk about.</p>
      </section>
      <section class="contact-actions">
        {!isFormVisible && !hasSent && <button type="button" class="primary-link reveal-button" onClick={() => setFormVisible(true)}>Send me an email <span class="link-arrow email-arrow" aria-hidden="true"></span></button>}
        {isFormVisible && !hasSent && !isConfirming && <form class="contact-form" name="contact" onSubmit={reviewForm}>
          <label>Name<input name="name" value={formData.name} onInput={updateField} required /></label>
          <label>Your email<input name="email" type="email" value={formData.email} onInput={updateField} required /></label>
          <label>Message<textarea name="message" rows="6" value={formData.message} onInput={updateField} required /></label>
          <div class="form-actions"><button class="form-submit" type="submit">Review message</button><button class="form-close" type="button" onClick={() => setFormVisible(false)}>Close</button></div>
        </form>}
        {isFormVisible && !hasSent && isConfirming && <section class="contact-confirmation">
        <p class="eyebrow">Review your message</p>
        <p><strong>From:</strong> {formData.name} ({formData.email})</p>
        <p class="message-preview">{formData.message}</p>
        <div class="form-actions"><button class="form-submit" type="button" onClick={submitForm}>Send email</button><button class="form-close" type="button" onClick={() => setConfirming(false)}>Edit message</button><button class="form-close" type="button" onClick={() => setFormVisible(false)}>Close</button></div>
        {status && <p class="form-status" aria-live="polite">{status}</p>}
      </section>}
        {hasSent && <p class="form-status contact-sent" aria-live="polite">{status}</p>}
        <p class="substack-note">You can also find me on <a href={siteSettings.linkedInUrl} target="_blank" rel="noopener noreferrer">LinkedIn</a>.</p>
      </section>
      <figure class="contact-photo" data-scroll-photo><img src={peacockPhoto} alt="Peacock" /></figure>
    </main>
  );
}
